module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0759-min.0189d598.jpg";